import { AbstractProvider } from './abstract';
import { Company as CompanyModel } from '../model';
import { MANAGEMENT, PROVIDER } from '../../actions/BCM_Constant';

export class Company extends AbstractProvider {
  management = MANAGEMENT.COMPANY;
  model = new CompanyModel();
  name = PROVIDER.COMPANIES;
}
